import { Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logoCircle from '../assets/logo-circle.webp';
import { useProductCategories } from '../hooks/useProductCategories';
import { CATEGORY_SHOP_LABELS } from '../lib/categories';

export function Footer() {
  // Only link categories that actually have products; falls back to just
  // "All Products" while loading or when nothing is categorized yet.
  const categories = useProductCategories() ?? [];

  return (
    <footer className="bg-coastal-900 text-white mt-12 pt-12 pb-6">
      <div className="container-max">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logoCircle} alt="Coastal Harvest Co." className="w-10 h-10 rounded-full bg-cream/10" />
              <h3 className="font-serif text-lg font-bold tracking-wide">
                <span className="text-white">Coastal Harvest</span>{' '}
                <span className="text-gold-400">Co.</span>
              </h3>
            </div>
            <p className="text-coastal-200 text-sm">
              Small-batch wellness snacks and clean seed crunch, crafted by a pharmacist on Long Island.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-gold-300">Shop</h4>
            <ul className="text-coastal-200 text-sm space-y-2">
              <li><Link to="/products" className="hover:text-white transition-colors">All Products</Link></li>
              {categories.map((cat) => (
                <li key={cat}>
                  <Link to={`/products?category=${cat}`} className="hover:text-white transition-colors">
                    {CATEGORY_SHOP_LABELS[cat]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-gold-300">Company</h4>
            <ul className="text-coastal-200 text-sm space-y-2">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/locations" className="hover:text-white transition-colors">Where to Find</Link></li>
              <li><Link to="/feedback" className="hover:text-white transition-colors">Leave Feedback</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-gold-300">Contact</h4>
            <div className="text-coastal-200 text-sm space-y-2">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span>Long Island, NY</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:Hello@Coastal-Harvest.com" className="hover:text-white transition-colors">Hello@Coastal-Harvest.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-coastal-700 pt-6 text-center">
          <p className="text-coastal-300 text-sm">&copy; {new Date().getFullYear()} Coastal Harvest Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
